
<template>
  <!-- eslint-disable vue/v-on-function-call -->
  <v-container fluid>
    <v-row>
      <v-col>
        <general-error v-if="!!generalError" />
        <v-progress-linear :active="isLoading" color="loader" indeterminate />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col v-if="editorConfig" class="editor">
        <editor
            v-model="content"
            api-key="no-api-key"
            lang="en_us"
            :init="editorConfig"
            tinymce-script-src="static/tinymce/tinymce.min.js" />
      </v-col>
    </v-row>

    <v-expansion-panels>
      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="search">
            <v-icon>
              public
            </v-icon>
            {{ $t('Опубликованная версия') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="elevation-2" justify="center">
            <v-col v-if="publishedContent" v-html="publishedContent" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="search">
            <v-icon>
              public_off
            </v-icon>
            {{ $t('Неопубликованая редакция') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="elevation-2" justify="center">
            <v-col v-if="content" v-html="content" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- <v-expansion-panel v-if="isMainAdmin" v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="search">
            <v-icon>
              code
            </v-icon>
            {{ $t('Исходный код') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row class="elevation-2 mb-4 pa-5">
            <v-col v-if="content">
              {{ content }}
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel> -->

      <v-expansion-panel v-test="{ panel: '' }">
        <v-expansion-panel-header>
          <div id="search">
            <v-icon>
              attach_file
            </v-icon>
            {{ $t('Доступные файлы') }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>

          <static-files-list />
          <!-- <static-folders /> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<style lang="sass" scoped>

</style>

<script>
// https://www.tiny.cloud/docs/ui-components/toolbarbuttons/

  import Vue from 'vue'
  import Editor from '@tinymce/tinymce-vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  // import StaticFolders from './StaticFolders.vue'
  import StaticFilesList from './StaticFilesList.vue'
  import { mapActions, mapState } from 'vuex'
  import { STATIC_PAGES } from '@/constants/store.js'

  /* eslint-disable no-multi-str */
  export default {
    components: {
      Editor,
      GeneralError,
      // StaticFolders,
      StaticFilesList
    },
    props: {
      tag: {
        type: [String, Number]
      }
    },
    data () {
      return {
        isLoading: false,
        apiKey: 'no-api-key',
        content: null
      }
    },
    computed: {
      ...mapState(STATIC_PAGES.NAMESPACE, {
        dbContent: state => (state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE] || {})
      }),
      editorLocale () {
        return this.systemLocale === 'ru'
          ? 'ru'
          : 'en_us'
      },
      editorConfig () {
        return {
          language: this.editorLocale,
          height: 500,
          menubar: true,
          menu: {
            file: { title: 'File', items: 'preview' },
            edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace' },
            view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen' },
            insert: { title: 'Insert', items: 'image link media template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime' },
            format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat' },
            tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | code wordcount' },
            table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
            help: { title: 'Help', items: 'help' }
          },
          plugins: [
            'hr advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen importcss',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar:
            'saveBtn publishBtn restoreBtn | undo redo | code preview | formatselect | fontselect | bold italic underline strike superscript subscript | backcolor forecolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent nonbreaking | image link anchor | hr | removeformat |   ',
          setup: this.setup,
          content_css: 'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
          importcss_append: true
        }
      },
      editedContent () {
        return this.dbContent.editedContent
      },
      publishedContent () {
        return this.dbContent.publishedContent
      },
      changesPublished () {
        return this.dbContent.changesPublished
      },
      canPublishChanges () {
        return !this.changesPublished &&
          this.editedContent !== this.publishedContent &&
          this.content === this.editedContent
      },
      canSaveChanges () {
        return this.content !== this.editedContent
      },
      canResetChanges () {
        return this.publishedContent &&
          this.editedContent !== this.publishedContent
      }
    },
    mounted () {

    },
    beforeDestroy () {
      this.clearStore()
    },
    created: function () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.tag) {
          vm.initialize()
        }
      })
    },
    methods: {
      ...mapActions(STATIC_PAGES.NAMESPACE, {
        getFullPageInfoAction: STATIC_PAGES.ACTIONS.GET_FULL_PAGE_INFO,
        editPageContentAction: STATIC_PAGES.ACTIONS.EDIT_PAGE_CONTENT,
        publishPageContentAction: STATIC_PAGES.ACTIONS.PUBLISH_PAGE_CONTENT,
        resetPageContentAction: STATIC_PAGES.ACTIONS.RESET_PAGE_CONTENT,
        clearFullPageInfoAction: STATIC_PAGES.ACTIONS.CLEAR_FULL_PAGE_INFO
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearFullPageInfoAction()
          ])
      },
      initialize: async function () {
        try {
          this.isLoading = true
          await Promise.all(
            [
              this.getFullPageInfo()
            ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      setup: function (editor) {
        const vm = this
        editor.ui.registry.addButton('saveBtn', {
          icon: 'save',
          tooltip: vm.$t('Сохранить изменения в черновике'),
          onAction: vm.editPageContent
        })

        editor.ui.registry.addButton('publishBtn', {
          icon: 'browse',
          tooltip: vm.$t('Опубликовать изменения'),
          onAction: vm.publishPageContent
        })

        editor.ui.registry.addButton('restoreBtn', {
          icon: 'restore-draft',
          tooltip: vm.$t('Отменить изменения в черновике'),
          onAction: vm.resetPageContent
        })
      },
      editPageContent: async function () {
        try {
          if (!this.canSaveChanges) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Внесите изменения перед сохранением черновика.'))
          }
          this.isLoading = true
          await this.editPageContentAction({
            tag: this.tag,
            content: this.content
          })
          await this.getFullPageInfo()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getFullPageInfo: async function () {
        await this.getFullPageInfoAction({
          tag: this.tag
        })
        this.content = this.editedContent
      },
      publishPageContent: async function () {
        try {
          if (!this.canPublishChanges) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Сохраните изменения перед публикацией.'))
          }
          this.isLoading = true
          await this.publishPageContentAction({
            tag: this.tag
          })
          await this.getFullPageInfo()

          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      resetPageContent: async function () {
        try {
          if (!this.canResetChanges) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Сбросить можно только сохраненные изменения. Для отмены несохраненных изменений пользуйтесь кнопками истории изменений.'))
          }
          this.isLoading = true
          await this.resetPageContentAction({
            tag: this.tag
          })
          await this.getFullPageInfo()

          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      }
    }
  }
</script>
